import { computed, ref, Ref, watch } from 'vue';
import { Validator } from '@/entities/validation';
import { TaskState } from './useTask';

export const useValidation = <Entity>(
  validate: Validator<Entity>,
  entity: Ref<Entity>,
  state: Ref<TaskState> | undefined = undefined,
) => {
  const showValidationErrors = ref(false);

  const mergedErrors = computed(() => [
    ...validate(entity.value),
    ...(state && 'error' in state.value) ? state.value.error.messages : [],
  ]);
  const validationErrors = computed(() => (showValidationErrors.value ? mergedErrors.value : []));
  const hasValidationErrors = computed(() => validationErrors.value.length > 0);
  const hasNoValidationErrors = computed(() => !hasValidationErrors.value);

  // This watches makes sure that the server errors are thrown away after the entity changes
  // TODO: make sure to only throw away server errors for a changed field, not all of them
  if (state) {
    watch(
      entity,
      () => {
        if ('error' in state.value) {
          state.value = { pending: false };
        }
      },
      {
        deep: true,
      },
    );
  }

  return {
    showValidationErrors,
    hasValidationErrors,
    hasNoValidationErrors,
    validationErrors,
  };
};
